import modal, { MODAL_MODULE_NAME } from './modal';
import loading, { LOADING_MODULE_NAME } from './loading';
import notification, { NOTIFICATION_MODULE_NAME } from "./notification";
import auth, { AUTH_MODULE_NAME } from './auth';
import lang, { LANG_MODULE_NAME } from './lang';
import profile, { PROFILE_MODULE_NAME } from "./profile";
import header, { HEADER_MODULE_NAME } from "@/store/modules/header";
import app, { APP_MODULE_NAME } from "@/store/modules/app";
import forex from "@/feature/Forex/store";
import openAccount from '@/feature/OpenAccount/store';
import { FOREX_MODULE_NAME } from "@/feature/Forex/store/constants";
import { OPEN_ACCOUNT_MODULE_NAME } from "@/feature/OpenAccount/store/constants";
import { PAYMENT_REQUIREMENTS_MODULE_NAME } from '@/feature/PaymentRequirements/store/constants';
import paymentRequirements from '@/feature/PaymentRequirements/store';
import forexHistory, { FOREX_HISTORY_MODULE_NAME } from '@/feature/TrHistory/store';

export default {
	[MODAL_MODULE_NAME]: modal,
	[LOADING_MODULE_NAME]: loading,
	[NOTIFICATION_MODULE_NAME]: notification,
	[AUTH_MODULE_NAME]: auth,
	[LANG_MODULE_NAME]: lang,
	[PROFILE_MODULE_NAME]: profile,
	[HEADER_MODULE_NAME]: header,
	[APP_MODULE_NAME]: app,
	[FOREX_MODULE_NAME]: forex,
	[OPEN_ACCOUNT_MODULE_NAME]: openAccount,
	[PAYMENT_REQUIREMENTS_MODULE_NAME]: paymentRequirements,
	[FOREX_HISTORY_MODULE_NAME]: forexHistory,
}
